






























import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'

settings =
  name: 'BoxChart'

  vue:
    props: ['title', 'data', 'options']

    components: {
      LoadingIndicator,
    }

    computed:
      hideHeader: ->
        @options?.hideHeader || false

      total: ->
        @data?.total || 0

      noDataAvailable: ->
        @isEmptyValue(@data)

    watch:
      data:
        immediate: true
        deep: true
        handler: ->
          @$emit 'cleanUp'
          @$nextTick => @$emit('draw') unless @noDataAvailable

export default VueOptions.vue settings
